module.exports = __webpack_public_path__ + "img/01.360732d6.png";